import { createStyles } from 'antd-style';

export const cardColors = [
  '#F7D6F7', // 粉
  '#D6E6FF', // 蓝
  '#FFD6B3', // 橙
  '#E6F7D6', // 绿
  '#E6E6FF', // 紫
  '#FFF7D6', // 黄
  '#D6FFF7', // 青
  '#FFD6E6', // 桃
];

// 卡片背景色/渐变色
const cardBgGradients = [
  'linear-gradient(135deg, #F8B195 0%, #F67280 100%)',
  'linear-gradient(135deg, #355C7D 0%, #6C5B7B 100%)',
  'linear-gradient(135deg, #C06C84 0%, #6C5B7B 100%)',
  'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
  'linear-gradient(135deg, #43cea2 0%, #185a9d 100%)',
  'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)',
  'linear-gradient(135deg, #f953c6 0%, #b91d73 100%)',
  'linear-gradient(135deg, #00c3ff 0%, #ffff1c 100%)',
];

const CARD_WIDTH = 265;
const CARD_HEIGHT = 392;
const CARD_PADDING = 18;
const MASK_HEIGHT = 260;

const useProposalSquareStyles = createStyles(({ token, css }) => ({

  pageWrapper: css`
    max-width: 900px;
    margin: 0 auto;
    background: var(--color-bg-chat);
    position: relative;
    padding-bottom: 30px;
  `,
  cardGrid: css`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  `,
  proposalCard: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: transform 0.18s, box-shadow 0.18s;
    cursor: pointer;
    background: #fff;
    position: relative;
    width: ${CARD_WIDTH}px;
    height: ${CARD_HEIGHT}px;
    overflow: hidden;
    &:hover {
      transform: translateY(-4px) scale(1.03);
      box-shadow: 0 8px 32px 0 rgba(88,189,109,0.12);
    }
  `,
  cardImage: css`
    width: 120px;
    height: 120px;
    border-radius: 32px;
    margin-bottom: 18px;
    object-fit: cover;
    background: #fff;
    box-shadow: 0 2px 8px 0 rgba(24,55,29,0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
  `,
  cardTitle: css`
    font-size: 18px;
    font-weight: 700;
    color: #18371D;
    margin-bottom: 8px;
    text-align: left;
    position: absolute;
    left: ${CARD_PADDING + 24}px;
    top: ${MASK_HEIGHT + CARD_PADDING}px;
    width: ${CARD_WIDTH - (CARD_PADDING + 24) * 2}px;
    z-index: 3;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  cardDesc: css`
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
    text-align: left;
    position: absolute;
    left: ${CARD_PADDING + 24}px;
    top: ${MASK_HEIGHT + CARD_PADDING + 36}px;
    width: ${CARD_WIDTH - (CARD_PADDING + 24) * 2}px;
    z-index: 3;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    min-height: 36px;
  `,
  cardBtnWrapper: css`
    position: absolute;
    left: ${CARD_PADDING + 24}px;
    top: ${MASK_HEIGHT + CARD_PADDING + 90}px;
    width: 87px;
    height: 35px;
    z-index: 3;
  `,
  cardBtn: css`
    border-radius: 20px;
    font-size: 15px;
    font-weight: 500;
    border: 1.5px solid #18371D;
    color: #18371D;
    background: #fff;
    padding: 0 24px;
    height: 35px;
    margin-top: auto;
    transition: all 0.18s;
    width: 100%;
    height: 100%;
    &:hover {
      background: #e6f7ff;
      color: #1890ff;
      border-color: #1890ff;
    }
  `,
  filterContainer: css`
    margin-bottom: 24px;
    padding: 16px;
    border-radius: 8px;
  `,
  // 8种背景色/渐变色
  ...[...Array(8).keys()].reduce((acc, idx) => {
    acc[`cardBg-${idx}`] = css`
      background: ${cardBgGradients[idx]};
    `;
    return acc;
  }, {}),
  thumbWrapper: css`
    position: absolute;
    top: ${CARD_PADDING}px;
    left: ${CARD_PADDING}px;
    right: ${CARD_PADDING}px;
    height: ${MASK_HEIGHT - CARD_PADDING}px;
    width: ${CARD_WIDTH - CARD_PADDING * 2}px;
    z-index: 2;
    pointer-events: none;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    height: ${MASK_HEIGHT - CARD_PADDING}px;
    /* 保证mask图片自适应 */
  `,
  thumbImg: css`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    mask-image: var(--mask-image);
    mask-size: 94% 94%;
    mask-position: center;
    mask-repeat: no-repeat;
    -webkit-mask-image: var(--mask-image);
      -webkit-mask-size: 94% 94%;
    -webkit-mask-position: center;
    -webkit-mask-repeat: no-repeat;
    background: #f5f5f5;
  `,
}));

export default useProposalSquareStyles; 